exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".img-info[data-v-011fb328]{position:absolute;top:0;left:0}.content[data-v-011fb328]{padding-left:55px}.highlight[data-v-011fb328]{font-size:20px;line-height:1;font-weight:700;margin:0;padding-top:5px}.arrow-link img[data-v-011fb328]{height:7px;margin:0 0 2px 3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-011fb328","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/period-modules/braster-disallowed.vue
// module id = 869
// module chunks = 0